import React from 'react';
export default function DiIconLive(props) {
  return React.createElement(
    "svg",
    {
      className: props.className,
      viewBox: "0 0 29 19"
    },
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        {
          transform: "translate(-354.000000, -398.000000)",
          fill: "#303030",
          fillRule: "nonzero"
        },
        React.createElement("path", { d: "M371.78317,417 C373.179632,417 374.312452,415.955062 374.312452,414.666031 L374.312452,411.746125 L379.663982,415.159175 C379.942311,415.354487 380.25483,415.437504 380.552662,415.437504 C381.363235,415.437504 382.120093,414.80274 382.120093,413.899421 L382.120093,401.350623 C382.124933,400.447305 381.368099,399.812541 380.557573,399.812541 C380.25483,399.812541 379.947223,399.900422 379.668894,400.09087 L374.312452,403.503919 L374.312452,400.584014 C374.312452,399.294983 373.179632,398.250045 371.78317,398.250045 L356.529281,398.250045 C355.132819,398.250045 354,399.294983 354,400.584014 L354,414.666031 C354,415.955062 355.132819,417 356.529281,417 L371.78317,417 Z M371.78317,415.437504 L356.529281,415.437504 C356.006812,415.437504 355.562496,415.085933 355.562496,414.666031 L355.562496,400.584014 C355.562496,400.164112 356.006812,399.812541 356.529281,399.812541 L371.78317,399.812541 C372.305639,399.812541 372.749955,400.164112 372.749955,400.584014 L372.749955,414.666031 C372.749955,415.085933 372.305639,415.437504 371.78317,415.437504 Z M380.562437,413.899421 L380.503834,413.835955 L374.312452,409.890661 L374.312452,405.35452 L380.562437,401.375037 L380.562437,413.899421 Z" })
      )
    )
  );
}